/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {PaydayGameAssets} from "../PaydayGameAssets";
import {Payday} from "../Payday";
import {GameClientConfiguration} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/GameClientConfiguration";

export class PaydayIntroConfig implements GameIntroViewConfig {

    colors:GameIntroColors = {
        slideShowColors : {
            backgroundColor : 0x000000, //Default 0x000000
            backgroundAlpha : 0.4, //Default 0.4
            bulletColor : 0xffffff, //Default 0xffffff

        },
        stampColor : 0xFFFFFF
    };

    stampConfig:StampConfig = {
        xBet: true,
        xGod: true,
        volatility : Volatility.MEDIUM
    };

    logoSprite:PIXI.Sprite;
    background:PIXI.Container;
    borderBottom:PIXI.Container;
    borderTop:PIXI.Container;
    logo:PIXI.Container;
    pages:SlideShowPage[];

    private betBoostAllowed:boolean = false;

    constructor() {
    }

    public init():Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add(PaydayGameAssets.MAIN_GAME_BACKGROUND, PaydayGameAssets.MAIN_GAME_BACKGROUND);
        imgLoader.add(PaydayGameAssets.IMAGES_LOGO, PaydayGameAssets.IMAGES_LOGO);
        imgLoader.add("introDiv", "resources/images/Intro_Divider.png");
        imgLoader.add("feature1_god_mode", "resources/images/intro_feature1_God_Mode.png");
        imgLoader.add("feature2", "resources/images/intro_feature2.png");
        imgLoader.add("betBoost", "resources/images/betBoost.png");

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    onShow() {
        this.logo.parent.addChild(this.logo);
    }
    onResize() {
        this.logo.y += 20;
        if (NolimitApplication.isLandscape){
            this.logo.scale.set(0.65, 0.65);
            this.logo.position.set((NolimitApplication.screenBounds.left - 20) / 2, 80);
            this.logo.visible = -(NolimitApplication.screenBounds.left - 30) > (this.logo.width);
        } else {
            this.logo.scale.set(1,1);
            this.logo.position.set(360, (NolimitApplication.screenBounds.top + 44) / 2);
            this.logo.visible = -(NolimitApplication.screenBounds.top - 88) > (this.logo.height);
        }
    }

    private initGraphics() {
        return new Promise((resolve, reject) => {

            this.background = new PIXI.Container();
            const bgSprite = new PIXI.Sprite(PaydayGameAssets.MAIN_GAME_BACKGROUND_TEXTURE);
            bgSprite.anchor.set(0.5, 0.5);
            this.background.addChild(bgSprite);

            this.borderTop = new PIXI.Container();
            const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
            topSprite.anchor.set(0.5, 0.5);
            this.borderTop.addChild(topSprite);

            this.borderBottom = new PIXI.Container();
            const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
            bottomSprite.rotation = Math.PI;
            bottomSprite.anchor.set(0.5, 0.5);
            this.borderBottom.addChild(bottomSprite);

            this.logo = new PIXI.Container();
            this.logoSprite = new PIXI.Sprite(PaydayGameAssets.IMAGES_LOGO_TEXTURE);
            this.logoSprite.anchor.set(0.5, 0.5);
            this.logo.addChild(this.logoSprite);
            this.onResize();

            const featureSprite2 = new PIXI.Sprite(ImgLoader.getImgTexture("feature2"));
            featureSprite2.anchor.set(0.5, 0.5);

            this.pages = [
                new SlideShowPage(),
            ];


            this.pages[0].addChild(featureSprite2);

            resolve(this);
        });

    }

    public gameClientConfigurationApplied(rules: GameClientConfiguration) {
        this.maybeAddGodModePage()

        if(Payday.apiPlugin.gameClientConfiguration.boostedBetAllowed) {
            this.addBoostPage();
        }

    }

    private maybeAddGodModePage() {
        const apiPlugin = Payday.apiPlugin;
        const godModeAllowed = !apiPlugin.bonusFeatures.notAllowedFeatures.some((feature) => feature.name == "GOD_MODE");

        if (!(godModeAllowed))
            return;

        const imgName = "feature1_god_mode";

        const page1 = new SlideShowPage();
        const featureSprite1 = new PIXI.Sprite(ImgLoader.getImgTexture(imgName));
        featureSprite1.anchor.set(0.5, 0.5);
        page1.addChild(featureSprite1);
        this.pages.unshift(page1)

    }

    private addBoostPage() {
        const betBoostImage = new PIXI.Sprite(ImgLoader.getImgTexture("betBoost"));
        betBoostImage.anchor.set(0.5, 0.5);
        const page = new SlideShowPage();
        page.addChild(betBoostImage)
        //this.pages.splice(0, 0, page);
        this.pages.push(page);
    }
}
